import React, {useState} from "react";
import {Info} from "lucide-react";

const InfoTooltip = ({ description }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <div className="relative inline-block">
      <button
        type="button"
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        className="text-gray-400 hover:text-gray-600 transition-colors"
        aria-label="Filter information"
      >
        <Info size={14} />
      </button>

      {showTooltip && (
        <div className="absolute z-10 left-0 top-6 w-64 p-3 bg-gray-900 text-white text-xs rounded-lg shadow-lg">
          <div className="absolute -top-1 left-2 w-2 h-2 bg-gray-900 transform rotate-45"></div>
          {description}
        </div>
      )}
    </div>
  );
};


export default InfoTooltip;